<article>
  <h1 appSlideup [slideUpDelay]="100">
    <span>About Us</span> <app-logo></app-logo>
  </h1>
  <p appSlideup [slideUpDelay]="200">
    <strong>Pink Soul</strong> is a women’s fashion brand dedicated to bringing
    stylish, affordable, and high-quality clothing to customers in the United
    States.
  </p>
  <p appSlideup [slideUpDelay]="300">
    All of our products are carefully sourced, ensuring the latest fashion
    trends reach your wardrobe with ease.
  </p>
  <p appSlideup [slideUpDelay]="400">
    We believe fashion should empower women to express their individuality and
    confidence. From everyday essentials to statement pieces, our collections
    are designed to fit seamlessly into your lifestyle.
  </p>
  <p appSlideup [slideUpDelay]="500">
    At Pink Soul, customer satisfaction is at the heart of everything we do. We
    are committed to providing excellent service, secure shopping, and a smooth
    delivery experience.
  </p>
  <p appSlideup [slideUpDelay]="600">
    Thank you for choosing <strong>Pink Soul</strong> — where fashion meets
    soul.
  </p>
</article>
